import axiosIns from '@/api/axios'

export const GET_PROJECT = (args) => {
    return axiosIns.get('/master-data/project', args)
}
export const GET_PROJECT_USER = (nik, args) => {
    const params = queryString.stringify(args); 
    return axiosIns.get(`/master-data/project-user/${nik}?${params}`);
}

